import styles from "./RemoveButton.module.css";

export function RemoveButton(props: { onRemove: () => void, className?: string }): JSX.Element {
    return (
        <span
            className={`${styles.removeButton} ${props.className ?? ""} glyphicon glyphicon-remove`}
            onClick={e => {
                e.preventDefault();
                props.onRemove();
            }}
        />
    );
}
